import { api } from './api';

export interface Agreement {
  id: number;
  title: string;
  slug: string;
  html_content?: string;
  version: number;
  type?: 'html' | 'pdf';
  pdf_path?: string;
  is_custom?: boolean;
  custom_agreement_id?: number;
}

export interface UserAgreement {
  id: number;
  agreement_title: string;
  agreement_version: number;
  signed_at: string;
  pdf_path?: string;
}

export interface SignedAgreement {
  id: number;
  user_name: string;
  user_email: string;
  username: string;
  agreement_name: string;
  agreement_version: number;
  signed_at: string;
  has_pdf: boolean;
}

export interface SignAgreementData {
  agreement_id: number;
  signature_data: string;
  custom_agreement_id?: number;
}

export interface AcceptCustomAgreementData {
  custom_agreement_id: number;
}

export const agreementService = {
  async getPendingAgreements(): Promise<Agreement[]> {
    const response = await api.get('/agreements/pending');
    return response.data.data;
  },

  async signAgreement(data: SignAgreementData): Promise<any> {
    const response = await api.post('/agreements/sign', data);
    return response.data;
  },

  async acceptCustomAgreement(data: AcceptCustomAgreementData): Promise<any> {
    const response = await api.post('/agreements/accept-custom', data);
    return response.data;
  },

  async getUserAgreements(): Promise<UserAgreement[]> {
    const response = await api.get('/agreements/user');
    return response.data.data;
  },

  async checkPendingAgreements(): Promise<boolean> {
    const response = await api.get('/agreements/check-pending');
    return response.data.has_pending;
  },

  async getAllSignedAgreements(): Promise<SignedAgreement[]> {
    const response = await api.get('/admin/legal/signed-agreements');
    return response.data.data;
  },

  async downloadAgreementPdf(userAgreementId: number): Promise<void> {
    const response = await api.get(`/agreements/download/${userAgreementId}`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'agreement.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
};
